export default __webpack_public_path__ + "static/media/flag-cz.9cfa729f.svg";